import React, { useEffect, useRef, useState } from "react";
import Button from "../../components/common/ui/Button.jsx";
import {
  DateInput,
  SelectInput,
  TextInput,
  RadioInput,
  CheckBoxInput,
  TextAreaInput,
} from "../../components/common/ui/Inputs/index.js";
import { useDispatch, useSelector } from "react-redux";
import { masterActions } from "../../_store/master.slice.js";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import Table from "../../components/common/table/Table.jsx";
import CommonModal from "../../components/common/ui/NotificationModal/CommonModal.js";
import ExcelExport from "./../../components/common/ui/Export/ExcelExport";
import PDFExport from "../../components/common/ui/Export/PDFExport.jsx";
import PrintExport from "../../components/common/ui/Export/PrintExport.jsx";
import { history } from "../../_helpers";
import { useLocation } from "react-router-dom";
import { publicUserActions } from "../../_store/publicUser.slice.js";
import { fDate, MinDate, Today } from "../../utils/formatTime.js";
import generatePublicUserMessagePDF from "../../components/common/export/Reports/generatePublicUserMessagePDF.jsx";
import CustomLoader from "../../components/common/ui/Loader.jsx";
import generatePublicUserPhotoPDF from "../../components/common/export/Reports/generatePublicUserPhotoPDF.js";
import loaddataimg from "../../assets/svg/load-data.svg";
import publicUserSchema from "../../validation/publicUserSchema.jsx";
import generateNewPublicUserMessagePDF from "../../components/common/export/Reports/generateNewPublicUserMessagePDF.js";
import { handleDateRangeBlur } from "../../hooks/useDateRangeBlur.jsx";
import { handleDateInput } from "../../hooks/useDateInputHandler.jsx";


function PublicUserReport() {
  const [messages, setMessages] = useState();
  const [photos, setPhotos] = useState();
  const [eventLog, setEventLog] = useState();

  const location = useLocation();
  const dispatch = useDispatch();
  const { row } = location.state || {};
  const commonFacilityCode = useSelector(
    (state) => state.auth.commonFacilityCode
  );
  const rows = useSelector((x) => x?.publicUser?.PublicUserrow);
  const {
    inmateLastName,
    inmateFirstName,
    reportMessageList,
    loadPhotoList,
    checkEventLogData,
    eventlogdownload,
    PublicUserCurrentTab,
    infoInformationList,
    loading,
  } = useSelector((x) => x.publicUser);
  const [isLoading, setIsLoading] = useState(false);
  const [ispdfLoading, setispdfLoading] = useState(false);
  const { direction } = useSelector((x) => x.dropdownOptions);
  const { user } = useSelector((x) => x.auth);
  const [messageList, setMessageList] = useState({
    facilityID: commonFacilityCode,
    puiConnectionID: row?.PublicUserID || rows?.PublicUserID,
    userFirstName: "",
    userLastName: "",
    userFirstNameID: 0,
    userLastNameID: 0,
    messageDirection: 0,
    dobStartDate: "",
    dobEndDate: "",
  });
  const messageInitial = {
    facilityID: commonFacilityCode,
    puiConnectionID: row?.PublicUserID || rows?.PublicUserID,
    userFirstName: "",
    userLastName: "",
    userFirstNameID: 0,
    userLastNameID: 0,
    messageDirection: 0,
    dobStartDate: "",
    dobEndDate: "",
  };

  const [reportMessageinitial, setReportMessageinitial] = useState(false);
  const [reportPhotoinitial, setReportPhotoinitial] = useState(false);
  const [reportEventLoginitial, setReportEventLoginitial] = useState(false);

  const [conversationFilterBy, setconversationFilterBy] = useState("DateRange");
  const [errors, setErrors] = useState({});
  const [photoErrors, setPhotoErrors] = useState({});


  const [photoList, setPhotoList] = useState({
    facilityID: commonFacilityCode,
    inmateID: 0,
    inmateResidentID: "",
    managementUserID: user?.ManagementUserID,
    userID: row?.PublicUserID || rows?.PublicUserID,
    userFirstName: row?.FirstName || rows?.FirstName,
    userLastName: row?.LaststName || rows?.LaststName,
    photoAccess: 0,
    inmateFirstName: "",
    inmateLastName: "",
    inmateFirstNameId: 0,
    inmateLastNameId: 0,
    subject: "",
    noticesFromDate: "",
    noticesToDate: "",
    activeStatus: 4,
    receiverRead: 4,
    pageNo: 1,
    rowCountPerPage: 1000,
    sortField: "PhotoCommID Asc",
  });
  const photoInitial = {
    facilityID: commonFacilityCode,
    inmateID: 0,
    inmateResidentID: "",
    managementUserID: user?.ManagementUserID,
    userID: row?.PublicUserID || rows?.PublicUserID,
    userFirstName: row?.FirstName || rows?.FirstName,
    userLastName: row?.LaststName || rows?.LaststName,
    photoAccess: 0,
    inmateFirstName: "",
    inmateLastName: "",
    inmateFirstNameId: 0,
    inmateLastNameId: 0,
    subject: "",
    noticesFromDate: "",
    noticesToDate: "",
    activeStatus: 4,
    receiverRead: 4,
    pageNo: 1,
    rowCountPerPage: 1000,
    sortField: "PhotoCommID Asc",
  };

  const [photoLoadValue, setPhotoLoadValue] = useState([]);
  const [allowphotoDownload, setAllowphotoDownload] = useState(false);
  const [eventlogList, setEventlogList] = useState({
    date: null,
    eventLogList: false,
  });
  const [errorMessage, setErrorMessage] = useState({});

  useEffect(() => {
    if (row?.PublicUserID || rows?.PublicUserID) {
      dispatch(
        publicUserActions.GetInmateFirstName({
          facilityID: commonFacilityCode,
          lastName: "",
          PublicUserID: row?.PublicUserID || rows?.PublicUserID,
        })
      );
      dispatch(
        publicUserActions.GetInmateLastName({
          facilityID: commonFacilityCode,
          firstName: "",
          PublicUserID: row?.PublicUserID,
        })
      );
    }
    dispatch(publicUserActions?.clearpublicUserReportPhoto());
    setMessageList(messageInitial);
    setPhotoList(photoInitial);
    dispatch(publicUserActions?.setClearReportMessageList());
    dispatch(publicUserActions?.setClearReportPhotoList());
    dispatch(publicUserActions?.setClearcheckEventLogDataResponse());
    setPhotoLoadValue([]);
    setEventlogList({
      date: null,
    });
    setReportMessageinitial(false);
    setReportPhotoinitial(false);
    setReportEventLoginitial(false);
  }, [
    row?.PublicUserID || rows?.PublicUserID,
    PublicUserCurrentTab === "publicuser-reports-tab",
  ]);
  // --------------------------------------------Message-----------
  let { ...updatedSearch } = messageList;
  const handleMessageSelectChange = (selectedOption, name) => {
    const handleFirstName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.userFirstNameID = selectedOption?.value || 0;

      dispatch(
        publicUserActions.GetInmateLastName({
          facilityID: commonFacilityCode,
          firstName: "",
          PublicUserID: row?.PublicUserID,
        })
      );
    };

    const handleLastName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.userLastNameID = selectedOption?.value || 0;

      updatedSearch.userFirstName = "";
      updatedSearch.userFirstNameID = 0;
      if (row?.PublicUserID) {
        dispatch(
          publicUserActions.GetInmateFirstName({
            facilityID: commonFacilityCode,
            lastName: updatedSearch?.userLastName,
            PublicUserID: row?.PublicUserID,
          })
        );
      }
    };

    switch (name) {
      case "userLastName":
        handleLastName();
        break;

      case "userFirstName":
        handleFirstName();
        break;

      default:
        updatedSearch[name] = selectedOption?.value || 0;
        setMessageList(updatedSearch);
        break;
    }

    setMessageList(updatedSearch);

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleMessageDateChange = (value, name) => {
    // switch (name) {
    //   case "dobStartDate":
    //     if (new Date(value) > new Date(messageList.dobEndDate)) {
    //       // If fromDate is greater than toDate, reset toDate to null or to fromDate
    //       setMessageList({
    //         ...messageList,
    //         [name]: fDate(value),
    //         dobEndDate: null, // You can set it to null or value depending on the desired behavior
    //       });
    //     } else {
    //       setMessageList({
    //         ...messageList,
    //         [name]: fDate(value),
    //       });
    //     }
    //     break;

    //   case "dobEndDate":
    //     if (new Date(value) < new Date(messageList.dobStartDate)) {
    //       // If toDate is less than fromDate, prevent the update or notify the user
    //       // alert("To Date cannot be earlier than From Date");
    //     } else {
    //       setMessageList({
    //         ...messageList,
    //         [name]: fDate(value),
    //       });
    //     }
    //     break;
    // }
    const date = fDate(value);
    // updatedSearch[name] = date;
    let updatedSearch = { ...messageList };

    updatedSearch[name] = date;

    if (name === "dobStartDate" && messageList.dobEndDate) {
      const start = new Date(date);
      const end = new Date(messageList.dobEndDate);

      const sixMonthsLater = new Date(start);
      sixMonthsLater.setMonth(start.getMonth() + 12);

      if (end > sixMonthsLater) {
        updatedSearch.dobEndDate = fDate(
          sixMonthsLater <= new Date()
            ? sixMonthsLater
            : new Date()
        );
      }
    }

    if (name === "dobEndDate" && messageList.dobStartDate) {
      const start = new Date(messageList.dobStartDate);
      const end = new Date(date);

      const sixMonthsEarlier = new Date(end);
      sixMonthsEarlier.setMonth(end.getMonth() - 12);

      if (start < sixMonthsEarlier) {
        updatedSearch.dobStartDate = fDate(sixMonthsEarlier);
      }
    }

    setMessageList(updatedSearch);
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    const minDate = MinDate();
    const today = Today();

    if (!value) return;

    let updatedStartDate = messageList.dobStartDate;
    let updatedEndDate = messageList.dobEndDate;

    const inputDate = new Date(value);

    const isValidDate = inputDate >= minDate && inputDate <= today;

    if (!isValidDate) return;

    if (fieldName === "dobStartDate") {
      updatedStartDate = fDate(value);

      if (updatedEndDate) {
        const start = new Date(updatedStartDate);

        const sixMonthsLater = new Date(start);
        sixMonthsLater.setMonth(start.getMonth() + 12);

        if (new Date(updatedEndDate) > sixMonthsLater) {
          updatedEndDate = fDate(
            sixMonthsLater <= today ? sixMonthsLater : today
          );
        }
      }
    }

    if (fieldName === "dobEndDate") {
      updatedEndDate = fDate(value);

      if (updatedStartDate) {
        const end = new Date(updatedEndDate);

        const sixMonthsEarlier = new Date(end);
        sixMonthsEarlier.setMonth(end.getMonth() - 12);

        if (new Date(updatedStartDate) < sixMonthsEarlier) {
          updatedStartDate = fDate(
            sixMonthsEarlier >= minDate ? sixMonthsEarlier : minDate
          );
        }
      }
    }

    setMessageList({
      ...messageList,
      dobStartDate: updatedStartDate,
      dobEndDate: updatedEndDate,
    });

    // if (fieldName === "dobStartDate") {
    //   if (
    //     updatedSearch.dobEndDate &&
    //     new Date(value) > new Date(updatedSearch.dobEndDate)
    //   ) {
    //     // Invalid: FromDate cannot be after ToDate
    //     isFromValid = false;
    //   }
    // } else if (fieldName === "dobEndDate") {
    //   if (
    //     updatedSearch.dobStartDate &&
    //     new Date(value) < new Date(updatedSearch.dobStartDate)
    //   ) {
    //     // Invalid: ToDate cannot be before FromDate
    //     isToValid = false;
    //   }
    // }

    // // Define date format used
    // const minDate = MinDate();
    // const today = Today();
    // const valueDate = new Date(value);
    // const isValidDate = valueDate >= minDate && valueDate <= today;

    // let updatedParam = {
    //   ...updatedSearch,
    //   dobStartDate:
    //     fieldName === "dobStartDate"
    //       ? isFromValid && isValidDate
    //         ? value
    //         : ""
    //       : updatedSearch.dobStartDate, // preserve existing value
    //   dobEndDate:
    //     fieldName === "dobEndDate"
    //       ? isToValid && isValidDate
    //         ? value
    //         : ""
    //       : updatedSearch.dobEndDate, // preserve existing value
    // };
    // setMessageList(updatedParam);
  };

  const handleMessageDateEnterKey = (event, name) => {
    if (event.key === "Enter" && updatedSearch[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleMessageDateChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const messageloadData = async (e) => {
    e.preventDefault();

    let newErrors = {
      userLastName: "",
      userFirstName: "",
      dobStartDate: "",
      dobEndDate: "",
    };

    // ✅ Username filter validation
    if (conversationFilterBy === "UserName") {
      if (!messageList?.userLastName || messageList.userLastNameID === 0) {
        newErrors.userLastName = "Please Select Public User Last Name";
      }

      if (!messageList?.userFirstName || messageList.userFirstNameID === 0) {
        newErrors.userFirstName = "Please Select Public User First Name";
      }
    }

    // ✅ DateRange filter validation
    if (conversationFilterBy === "DateRange") {
      if (!messageList?.dobStartDate) {
        newErrors.dobStartDate = "Please Select From Date";
      }

      if (!messageList?.dobEndDate) {
        newErrors.dobEndDate = "Please Select To Date";
      }
      setReportMessageinitial(false);
    }

    setErrors(newErrors);

    // ✅ Stop submit if any validation exists
    if (
      newErrors.userLastName ||
      newErrors.userFirstName ||
      newErrors.dobStartDate ||
      newErrors.dobEndDate
    ) {
      return;
    }

    await dispatch(
      publicUserActions.LoadMessageConversationPublicUser(messageList)
    );
    setReportMessageinitial(true);
    setMessages(messages);
  };
  const handleMessageCancel = () => {
    dispatch(publicUserActions.setClearReportMessageList());
    setReportMessageinitial(false);
  };

  const handleMessagePDF = (e) => {
    e.preventDefault();

    const title = "Message Conversation";
    const messageConversation = reportMessageList?.map((obj) => ({
      Sender: obj?.Sender || "         N/A         ",
      MessageSentDate: obj?.MessageSentDate || "         N/A         ",
      ReceiverRead: obj?.ReceiverRead || "         N/A         ",
      MessageSubject: obj?.MessageSubject || "         N/A         ",
      MessageBody: obj?.MessageBody || "         N/A         ",
      InmateFullName: obj?.InmateFullName || "         N/A         ",
      PublicUserFullName: obj?.PublicUserFullName || "N/A",
      MessageReceiveDate: obj?.MessageReceiveDate || "         N/A         ",
    }));
    const inmateName = reportMessageList[0]?.PublicUserFullName;

    // generatePublicUserMessagePDF(inmateName, messageConversation, title);
    generateNewPublicUserMessagePDF(inmateName, messageConversation, title);
    setReportMessageinitial(false);
    dispatch(publicUserActions.setClearReportMessageList());
  };
  const handleMessages = () => {
    setMessages(!messages);
  };

  // --------------------------------------------Short BY Filter-----------
  const handleFilterChange = (value) => {
    setconversationFilterBy(value);

    if (value === "UserName") {
      setMessageList((prev) => ({
        ...prev,
        dobStartDate: "",
        dobEndDate: "",
        messageDirection: 0,
      }));
      setErrors((prev) => ({
        ...prev,
        userFirstName: "",
        userLastName: "",
        dobStartDate: "",
        dobEndDate: "",
      }));
    }

    if (value === "DateRange") {
      setMessageList((prev) => ({
        ...prev,
        userFirstNameID: 0,
        userLastNameID: 0,
      }));

      setErrors((prev) => ({
        ...prev,
        userFirstName: "",
        userLastName: "",
        dobStartDate: "",
        dobEndDate: "",
        userFirstNameID: 0,
        userLastNameID: 0,
      }));
    }
  };

  // --------------------------------------------Message-----------

  // ------------------------------------------------Photos--------------
  const handlePhotos = () => {
    setPhotos(!photos);
  };
  let { ...updatedPhotoList } = photoList;
  const handlePhotosSelectChange = (selectedOption, name) => {
    const handleFirstName = () => {
      updatedPhotoList[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedPhotoList.inmateFirstNameId = selectedOption?.value || 0;

      dispatch(
        publicUserActions.GetInmateLastName({
          facilityID: commonFacilityCode,
          firstName: "",
          PublicUserID: row?.PublicUserID,
        })
      );
    };

    const handleLastName = () => {
      updatedPhotoList[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedPhotoList.inmateLastNameId = selectedOption?.value || 0;

      updatedPhotoList.inmateFirstName = "";
      updatedPhotoList.inmateFirstNameId = 0;
      if (row?.PublicUserID) {
        dispatch(
          publicUserActions.GetInmateFirstName({
            facilityID: commonFacilityCode,
            lastName: updatedPhotoList?.inmateLastName,
            PublicUserID: row?.PublicUserID,
          })
        );
      }
    };

    switch (name) {
      case "inmateLastName":
        handleLastName();
        break;

      case "inmateFirstName":
        handleFirstName();
        break;

      default:
        updatedPhotoList[name] = selectedOption?.value;
        setMessageList(updatedPhotoList);
        break;
    }

    setPhotoList(updatedPhotoList);
  };

  const handlePhotoDateChange = (value, name) => {
    const date = fDate(value);

    let updatedSearch = { ...photoList };

    updatedSearch[name] = date;

    setPhotoErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    if (name === "noticesFromDate" && photoList.noticesToDate) {
      const start = new Date(date);
      const end = new Date(photoList.noticesToDate);

      const sixMonthsLater = new Date(start);
      sixMonthsLater.setMonth(start.getMonth() + 6);

      if (end > sixMonthsLater) {
        updatedSearch.noticesToDate = fDate(
          sixMonthsLater <= new Date()
            ? sixMonthsLater
            : new Date()
        );
      }
    }

    if (name === "noticesToDate" && photoList.noticesFromDate) {
      const start = new Date(photoList.noticesFromDate);
      const end = new Date(date);

      const sixMonthsEarlier = new Date(end);
      sixMonthsEarlier.setMonth(end.getMonth() - 6);

      if (start < sixMonthsEarlier) {
        updatedSearch.noticesFromDate = fDate(sixMonthsEarlier);
      }
    }
    setPhotoList(updatedSearch);

  };

  const handlePhotoDateEnterKey = (event, name) => {
    handleDateInput({
      event,
      name,
      minDate: new Date(2017, 0, 1),
      maxDate: new Date(),
      onBlur: handleDateBlurPhoto,
    });
  };

  const handleDateBlurPhoto = (e, fieldName, manualValue) => {
    const value = manualValue || e.target.value;

    const updatedParam = handleDateRangeBlur({
      value,
      fieldName,
      startKey: "noticesFromDate",
      endKey: "noticesToDate",
      searchdata: photoList,
      setErrorMessage: setPhotoErrors,
      monthrange: 6
    });

    setPhotoList(updatedParam);
  };

  // const handleDateBlurPhoto = (e, fieldName) => {

  //   const value = e.target.value;

  //   const minDate = MinDate();
  //   const today = Today();

  //   if (!value) return;

  //   let updatedStartDate = photoList.noticesFromDate;
  //   let updatedEndDate = photoList.noticesToDate;

  //   const inputDate = new Date(value);

  //   const isValidDate = inputDate >= minDate && inputDate <= today;

  //   if (!isValidDate) return;

  //   if (fieldName === "noticesFromDate") {
  //     updatedStartDate = fDate(value);

  //     if (updatedEndDate) {
  //       const start = new Date(updatedStartDate);

  //       const sixMonthsLater = new Date(start);
  //       sixMonthsLater.setMonth(start.getMonth() + 6);

  //       if (new Date(updatedEndDate) > sixMonthsLater) {
  //         updatedEndDate = fDate(
  //           sixMonthsLater <= today ? sixMonthsLater : today
  //         );
  //       }
  //     }
  //   }

  //   if (fieldName === "noticesToDate") {
  //     updatedEndDate = fDate(value);

  //     if (updatedStartDate) {
  //       const end = new Date(updatedEndDate);

  //       const sixMonthsEarlier = new Date(end);
  //       sixMonthsEarlier.setMonth(end.getMonth() - 6);

  //       if (new Date(updatedStartDate) < sixMonthsEarlier) {
  //         updatedStartDate = fDate(
  //           sixMonthsEarlier >= minDate ? sixMonthsEarlier : minDate
  //         );
  //       }
  //     }
  //   }
  //   setPhotoList({
  //     ...photoList,
  //     noticesFromDate: updatedStartDate,
  //     noticesToDate: updatedEndDate,
  //   });
  // };

  // const handlePhotoDateEnterKey = (event, name) => {
  //   if (event.key === "Enter" && photoList[name] === "") {
  //     const currentDate = new Date();

  //     // Set today's date using the same logic as your handleDateChange
  //     handlePhotoDateChange(currentDate, name);
  //   }

  //   const regex = /^[0-9/]$/; // Allow numbers and "/"

  //   if (
  //     !regex.test(event.key) &&
  //     event.key !== "Backspace" &&
  //     event.key !== "Delete" &&
  //     !(event.ctrlKey && event.key === "v")
  //   ) {
  //     event.preventDefault();
  //   }

  //   // Auto-insert '/' when typing
  //   const input = event.target.value;

  //   if (event.key !== "Backspace" && event.key !== "Delete") {
  //     if (input?.length === 2 || input?.length === 5) {
  //       event.target.value = input + "/";
  //     }
  //   }
  // };

  const photoloadData = (e) => {
    e.preventDefault();


    let newErrors = {
      NoticesFromDate: "",
      NoticesToDate: "",
    };

    // ✅ DateRange filter validation
    if (!photoList?.noticesFromDate) {
      newErrors.noticesFromDate = "Please Select From Date";
    }

    if (!photoList?.noticesToDate) {
      newErrors.noticesToDate = "Please Select To Date";
    }

    setPhotoErrors(newErrors);

    // ✅ Stop submit if any validation exists
    if (
      newErrors.noticesFromDate ||
      newErrors.noticesToDate
    ) {
      return;
    }

    setIsLoading(true);

    dispatch(publicUserActions.LoadPhotoSearch({
      ...photoList,
      userLastName: row?.LastName || rows?.LastName || infoInformationList?.LastName,
      userFirstName: row?.FirstName || rows?.FirstName || infoInformationList?.FirstName
    })).then((x) => {
      setIsLoading(false);
    })
    //setPhotoLoadValue(loadPhotoList?.DataList || []);
    setReportPhotoinitial(true);
  };
  const handlePhotoCancel = () => {
    //setPhotoLoadValue([]);
    dispatch(publicUserActions?.clearpublicUserReportPhoto());
    setReportPhotoinitial(false);
  };

  const handlePhotoPDF = () => {
    setispdfLoading(true);

    setTimeout(() => {
      const title = `Photos_${row?.LastName || infoInformationList?.LastName || rows?.LastName
        }_${row?.FirstName || infoInformationList?.FirstName || rows?.FirstName}`;

      const photoDetails = loadPhotoList?.DataList?.map((obj) => ({
        Subject: obj?.PhotoSubject || "N/A",
        From: obj?.PhotoFrom || "N/A",
        PhotoCost: obj?.PhotoCost || "N/A",
        SendDate: obj?.PhotoSentDate || "N/A",
        Status: obj?.PhotoActionStatus || "N/A",
        FacilityName: obj?.FacilityCode || "N/A",
        base64: obj?.PhotoBinaryData || obj?.PhotoAttachPath || "N/A",
        To: obj?.PhotoTo || "N/A",
      }));

      const inmateName =
        row?.PublicUserFullName ||
        rows?.PublicUserFullName ||
        infoInformationList?.PublicUserFullName || (infoInformationList?.LastName + " " + infoInformationList?.FirstName) || "N/A";

      generatePublicUserPhotoPDF(inmateName, photoDetails, title);

      setReportPhotoinitial(false);
      dispatch(publicUserActions?.clearpublicUserReportPhoto());

      setispdfLoading(false); // ✅ stop loader AFTER generation
    }, 0); // small delay to allow UI render
  };

  // ------------------------------------------------Photos--------------

  const handleEventLog = () => {
    setEventLog(!eventLog);
  };

  const handleEventDateChange = (date) => {
    let formattedDate = fDate(date);
    setEventlogList({
      ...eventlogList,
      date: formattedDate,
    });
    setErrorMessage((prev) => ({
      ...prev,
      date: "",
    }));
  };
  const [submitted, setSubmitted] = useState(false);

  const eventLogloadData = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    setErrorMessage({});
    setEventlogList((prev) => ({
      ...prev,
      eventLogList: true,
    }));
    if (document?.getElementsByClassName("input-error").length > 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    const { error } = publicUserSchema(eventlogList);
    if (error?.details) {
      error?.details?.forEach((e) => {
        const { path } = e;
        // Set the error message for each invalid field
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: e.message,
        }));

        // Safely select the input element by name
        const inputElement = document.querySelector(`input[name="${path}"]`);
        if (inputElement) {
          // Add the input-error className if the element exists
          inputElement.classList.add("input-error");
        }
      });
      return;
    }

    await dispatch(
      publicUserActions.LoadEventLogData({
        userID: row?.PublicUserID || rows?.PublicUserID,
        publicUsername: row?.UserName || rows?.UserName,
        EventLogDate: eventlogList?.date,
      })
    );
    setReportEventLoginitial(true);
    setMessages(messages);
  };

  const handleBlur = (e, fieldName) => {
    let { value } = e.target;
    let isValid = true;

    if (eventlogList.date && new Date(value) < new Date(eventlogList.date)) {
      // Invalid: ToDate cannot be before FromDate
      isValid = false;
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...eventlogList,
      date:
        fieldName === "date"
          ? isValid && isValidDate
            ? value
            : ""
          : eventlogList.date, // preserve existing value
    };
    setEventlogList(updatedParam);

    if (submitted) {
      setErrorMessage({});
      setEventlogList((prev) => ({
        ...prev,
        eventLogList: true,
      }));
      if (document?.getElementsByClassName("input-error").length > 0) {
        document.querySelector(".input-error").classList.remove("input-error");
      }

      const { error } = publicUserSchema(updatedParam);

      if (error?.details) {
        error?.details?.forEach((e) => {
          const { path } = e;
          // Set the error message for each invalid field
          setErrorMessage((prev) => ({
            ...prev,
            [path.toString()]: e.message,
          }));

          // Safely select the input element by name
          const inputElement = document.querySelector(`input[name="${path}"]`);
          if (inputElement) {
            // Add the input-error className if the element exists
            inputElement.classList.add("input-error");
          }
        });
        return;
      }
    }
  };

  const handleEventLogDateEnterKey = (event, name) => {
    if (event.key === "Enter" && eventlogList[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleEventDateChange(currentDate);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleEventLogCancel = () => {
    dispatch(publicUserActions.setClearcheckEventLogDataResponse());
    setReportEventLoginitial(false);
  };
  const handleEventLogDownload = () => {
    dispatch(
      publicUserActions.GetEventLogFileAsBase64({
        userID: row?.PublicUserID || rows?.PublicUserID,
        publicUsername: row?.UserName || rows?.UserName,
        EventLogDate: eventlogList?.date,
      })
    )
      .unwrap()
      .then(() => { })
      .catch((err) => {
        console.error("Error downloading event log:", err.message);
      });

    setTimeout(() => {
      dispatch(publicUserActions.setClearcheckEventLogDataResponse());
      setReportEventLoginitial(false);
    }, 1000);
  };
  const handleBack = () => {
    history.navigate("PublicUserList");
  };

  if (loading || isLoading) return <CustomLoader />;

  return (
    <div>
      <div className="d-none" id="output"></div>
      <div className="d-none" id="outputBody"></div>
      <div className=" p-2 ">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap">
          <h4 className="inner-subheader-bg text-color">
            <i class="fa fa-reorder me-2"></i>Reports
          </h4>
          <Button
            label="Back"
            type="button"
            //className="btn btn-danger"
            onClick={handleBack}
            variant="danger"
            icon={"fa-solid fa-angle-left"}
            status={"primary"}
            disabled={false}
          />
        </div>
      </div>
      {/* {messages} */}
      <div className="accordion" id="accordion-messages">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingmessages">
              <button
                className="accordion-button collapsed text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#messages-accordian"
                onClick={handleMessages}
                aria-expanded="false"
              >
                {" "}
                Messages
                {/* <CheckBoxInput
                  label="MESSAGES"
                  name="messages"
                  id="messages"
                  onClick={handleMessages}
                  checked={messages}
                /> */}
              </button>
            </div>
            <div
              id="messages-accordian"
              className={`accordion-collapse
                ${messages ? "show" : "collapse"}`}
              aria-labelledby="headingmessages"
            >
              <div className="accordion-body p-0 m-3">
                <div className=" p-2 ">
                  <h4 className="inner-header-bg text-color">
                    {" "}
                    <i className="fa-solid fa-filter me-2"></i>Filter{" "}
                  </h4>
                  <form>
                    <div className="row">
                      <div className="row align-items-center mb-4">
                        <div className="col-md-4 col-sm-12 d-flex flex-wrap align-items-center">
                          <label className="fs-5 me-2" style={{ minWidth: "150px" }}>
                            Public User Last Name :
                          </label>

                          <strong className="fs-5">
                            {row?.LastName ||
                              rows?.LastName ||
                              infoInformationList?.LastName}
                          </strong>
                        </div>
                        <div className="col-md-4 col-sm-12 d-flex flex-wrap align-items-center">
                          <label className="fs-5 me-2" style={{ minWidth: "150px" }}>
                            Public User First Name :
                          </label>
                          <strong className="fs-5">
                            {row?.FirstName ||
                              rows?.FirstName ||
                              infoInformationList?.FirstName}
                          </strong>
                        </div>


                        <div className="col-md-4 col-sm-12 d-flex align-items-center">
                          <label className="fs-5 me-2">
                            Sort By :
                          </label>

                          <div className="fs-5">

                            <label className="me-3">
                              <input
                                type="radio"
                                name="filterBy"
                                value="DateRange"
                                checked={conversationFilterBy === "DateRange"}
                                disabled={
                                  reportMessageinitial?.length > 0 &&
                                  reportMessageList &&
                                  conversationFilterBy === "UserName"
                                }
                                onChange={(e) => handleFilterChange(e.target.value)}
                              />
                              {" "}Date Range
                            </label>

                            <label className="ms-2">
                              <input
                                type="radio"
                                name="filterBy"
                                value="UserName"
                                checked={conversationFilterBy === "UserName"}
                                disabled={
                                  reportMessageinitial?.length > 0 &&
                                  reportMessageList &&
                                  conversationFilterBy === "DateRange"
                                }
                                onChange={(e) => handleFilterChange(e.target.value)}
                              />
                              {" "}User Name
                            </label>

                          </div>
                        </div>

                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <SelectInput
                            options={inmateLastName}
                            value={messageList?.userLastNameID}
                            handleChange={(selectedOption) =>
                              handleMessageSelectChange(
                                selectedOption,
                                "userLastName"
                              )
                            }
                            isMulti={false}
                            closeMenuOnSelect={true}
                            isDisabled={reportMessageList?.length > 0}
                            isLoading={false}
                            isClearable={
                              messageList?.userLastNameID
                                ? true
                                : false && messageList?.userLastNameID !== 0
                            }
                            label="Inmate Last Name"
                            required={conversationFilterBy === "UserName"}
                            errorMessage={errors.userLastName}
                          />
                          {errors.userLastName && (
                            <div className="text-danger fw-700 fs-6">
                              {errors.userLastName}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <SelectInput
                            options={inmateFirstName}
                            value={messageList?.userFirstNameID}
                            handleChange={(selectedOption) =>
                              handleMessageSelectChange(
                                selectedOption,
                                "userFirstName"
                              )
                            }
                            isMulti={false}
                            closeMenuOnSelect={true}
                            isDisabled={reportMessageList?.length > 0}
                            isLoading={false}
                            isClearable={
                              messageList?.userFirstNameID
                                ? true
                                : false && messageList?.userFirstNameID !== 0
                            }
                            label="Inmate First Name"
                            required={conversationFilterBy === "UserName"}
                            errorMessage={errors.userFirstName}
                          />
                          {errors.userFirstName && (
                            <div className="text-danger fw-700 fs-6">
                              {errors.userFirstName}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <DateInput
                            value={messageList?.dobStartDate}
                            handleChange={(e) =>
                              handleMessageDateChange(e, "dobStartDate")
                            }
                            name="dobStartDate"
                            label={"From Date"}
                            // minDate = {}
                            // maxDate={
                            //   messageList.dobEndDate
                            //     ? messageList.dobEndDate
                            //     : new Date()
                            // }
                            maxDate={
                              messageList?.dobEndDate
                                ? messageList?.dobEndDate
                                : new Date()
                            }
                            minDate={new Date(2017, 0, 1)}
                            isClearable={
                              messageList?.dobStartDate !== "" &&
                              messageList?.dobStartDate !== null
                            }
                            // required={false}
                            // disabled={reportMessageList?.length > 0}
                            required={conversationFilterBy === "DateRange"}
                            disabled={reportMessageList?.length > 0 || conversationFilterBy === "UserName"}
                            yearDropDown={false}
                            monthDropDown={false}
                            className={false ? "disabled-date-input" : ""} // Add class conditionally
                            handleBlur={(e) =>
                              handleDateBlur(e, "dobStartDate")
                            }
                            handleKeyDown={(e) =>
                              handleMessageDateEnterKey(e, "dobStartDate")
                            }
                            errorMessage={messageList?.dobStartDate ? {} : errors}
                          ></DateInput>
                          {/* {errors.dobStartDate && (
                            <div className="text-danger fw-700 fs-6">
                              {errors.dobStartDate}
                            </div>
                          )} */}
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <DateInput
                            value={messageList?.dobEndDate}
                            handleChange={(e) =>
                              handleMessageDateChange(e, "dobEndDate")
                            }
                            name="dobEndDate"
                            minDate={
                              messageList?.dobStartDate
                                ? messageList?.dobStartDate
                                : new Date(2017, 0, 1)
                            }
                            label={"To Date"}
                            //maxDate={new Date()}
                            maxDate={
                              messageList?.dobStartDate
                                ? new Date(
                                  Math.min(
                                    new Date(messageList?.dobStartDate).setMonth(
                                      new Date(messageList?.dobStartDate).getMonth() + 12
                                    ),
                                    new Date()
                                  )
                                )
                                : new Date()
                            }
                            isClearable={
                              messageList?.dobEndDate !== "" &&
                              messageList?.dobEndDate !== null
                            }
                            required={conversationFilterBy === "DateRange"}
                            disabled={reportMessageList?.length > 0 || conversationFilterBy === "UserName"}
                            //required={false}
                            // disabled={reportMessageList?.length > 0}
                            yearDropDown={false}
                            monthDropDown={false}
                            handleBlur={(e) => handleDateBlur(e, "dobEndDate")}
                            handleKeyDown={(e) =>
                              handleMessageDateEnterKey(e, "dobEndDate")
                            }
                            errorMessage={messageList?.dobEndDate ? {} : errors}
                          ></DateInput>
                          {/* {errors.dobEndDate && (
                            <div className="text-danger fw-700 fs-6">
                              {errors.dobEndDate}
                            </div>
                          )} */}
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <SelectInput
                            options={direction}
                            value={messageList?.messageDirection}
                            handleChange={(selectedOption) =>
                              handleMessageSelectChange(
                                selectedOption,
                                "messageDirection"
                              )
                            }
                            isDisabled={reportMessageList?.length > 0 || conversationFilterBy === "UserName"}
                            placeholder="Select Direction"
                            label="Direction"
                            isClearable={messageList?.messageDirection !== 0}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="mt-3 d-flex flex-wrap  gap-3">

                      {(reportMessageinitial && reportMessageList?.length > 0) ? (
                        <div className="d-flex flex-wrap align-items-start">
                          <label
                            className="fs-5 fw-bold"
                            style={{ color: "#009759" }}
                          >
                            Data loaded successfully. Click download button to
                            export PDF.
                          </label>
                        </div>
                      ) :
                        (reportMessageinitial && reportMessageList?.length === 0) ? (
                          <div className="d-flex flex-wrap align-items-start">
                            <label className="fs-5 fw-bold text-danger">
                              No Data Available
                            </label>
                          </div>
                        )
                          : (conversationFilterBy === "DateRange") ?
                            <p className="fst-italic font-bold">
                              Note : You can select a date range of up to one year only.
                            </p>
                            : ""}
                      <div className="d-flex flex-wrap ms-auto">
                        {reportMessageList?.length === 0 && (
                          <Button
                            className="me-2"
                            label={"LOAD DATA"}
                            type={"submit"}
                            variant="danger"
                            status={"btn-label"}
                            imgsrc={loaddataimg}
                            disabled={false}
                            onClick={messageloadData}
                          />
                        )}
                        {reportMessageList?.length > 0 && (
                          <>
                            <Button
                              className="me-2"
                              label={"CANCEL"}
                              type={"submit"}
                              variant="danger"
                              status={"primary"}
                              icon={"fa-solid fa-xmark"}
                              disabled={false}
                              onClick={handleMessageCancel}
                            />
                            <Button
                              className="me-2"
                              icon={"fa-solid fa-download"}
                              label={"Download"}
                              type={"submit"}
                              variant="danger"
                              status={"success"}
                              disabled={false}
                              onClick={handleMessagePDF}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* photos */}
      <div className="accordion" id="accordion-photos">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingphotos">
              <button
                className="accordion-button collapsed text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#photos-accordian"
                onClick={handlePhotos}
                aria-expanded="false"
              >
                Photos
                {/* <CheckBoxInput
                  name="photos"
                  id="photos"
                  onClick={handlePhotos}
                  checked={photos}
                /> */}
              </button>
            </div>
            <div
              id="photos-accordian"
              className={`accordion-collapse
                ${photos ? "show" : "collapse"}`}
              aria-labelledby="headingphotos"
            >
              <div className="accordion-body p-0 m-4">
                <div className=" p-2 ">
                  <h4 className="inner-header-bg text-color">
                    {" "}
                    <i className="fa-solid fa-filter me-2"></i>Filter{" "}
                  </h4>
                  <form>
                    <div className="row">
                      <div className="m-0 d-flex flex-wrap align-items-center">
                        <div className="col-md-4 col-sm-12 d-flex flex-wrap align-items-center me-2">
                          <label className="fs-5" style={{ minWidth: "150px" }}>
                            Public User Last Name :
                          </label>

                          <strong className="fs-5 text-end mx-2">
                            {row?.LastName ||
                              rows?.LastName ||
                              infoInformationList?.LastName}
                          </strong>
                        </div>

                        {/* Limit */}
                        <div className="col-md-4 col-sm-12 d-flex flex-wrap align-items-center">
                          <label className="fs-5" style={{ minWidth: "150px" }}>
                            Public User First Name :
                          </label>
                          <strong className="fs-5 text-end mx-2">
                            {row?.FirstName ||
                              rows?.FirstName ||
                              infoInformationList?.FirstName}
                          </strong>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <SelectInput
                            options={inmateLastName}
                            value={photoList?.inmateLastNameId}
                            handleChange={(selectedOption) =>
                              handlePhotosSelectChange(
                                selectedOption,
                                "inmateLastName"
                              )
                            }
                            isMulti={false}
                            closeMenuOnSelect={true}
                            isDisabled={loadPhotoList?.DataList?.length > 0}
                            isLoading={false}
                            isClearable={photoList?.inmateLastNameId !== 0}
                            label="Inmate Last Name"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <SelectInput
                            options={inmateFirstName}
                            value={photoList?.inmateFirstNameId}
                            handleChange={(selectedOption) =>
                              handlePhotosSelectChange(
                                selectedOption,
                                "inmateFirstName"
                              )
                            }
                            minDate={new Date(2017, 0, 1)}
                            isMulti={false}
                            closeMenuOnSelect={true}
                            isDisabled={loadPhotoList?.DataList?.length > 0}
                            isLoading={false}
                            isClearable={photoList?.inmateFirstNameId !== 0}
                            label="Inmate First Name"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <DateInput
                            value={photoList?.noticesFromDate}
                            handleChange={(e) =>
                              handlePhotoDateChange(e, "noticesFromDate")
                            }
                            name="noticesFromDate"
                            label={"From Date"}
                            maxDate={
                              photoList.noticesToDate
                                ? photoList.noticesToDate
                                : new Date()
                            }
                            minDate={new Date(2017, 0, 1)}
                            required={true}
                            disabled={loadPhotoList?.DataList?.length > 0}
                            isClearable={
                              photoList?.noticesFromDate !== "" &&
                              photoList?.noticesFromDate !== null
                            }
                            errorMessage={photoErrors}
                            yearDropDown={false}
                            monthDropDown={false}
                            className={false ? "disabled-date-input" : ""}
                            handleBlur={(e) =>
                              handleDateBlurPhoto(e, "noticesFromDate")
                            }
                            handleKeyDown={(e) =>
                              handlePhotoDateEnterKey(e, "noticesFromDate")
                            }
                          ></DateInput>
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <DateInput
                            value={photoList?.noticesToDate}
                            handleChange={(e) =>
                              handlePhotoDateChange(e, "noticesToDate")
                            }
                            name="noticesToDate"
                            label={"To Date"}
                            minDate={
                              photoList?.noticesFromDate
                                ? photoList?.noticesFromDate
                                : new Date(2017, 0, 1)
                            }
                            maxDate={
                              photoList?.noticesFromDate
                                ? new Date(
                                  Math.min(
                                    new Date(photoList.noticesFromDate).setMonth(
                                      new Date(photoList.noticesFromDate).getMonth() + 6
                                    ),
                                    new Date()
                                  )
                                )
                                : new Date()
                            }
                            errorMessage={photoErrors}
                            required={true}
                            isClearable={
                              photoList?.noticesToDate !== "" &&
                              photoList?.noticesToDate !== null
                            }
                            disabled={loadPhotoList?.DataList?.length > 0}
                            yearDropDown={false}
                            monthDropDown={false}
                            handleBlur={(e) =>
                              handleDateBlurPhoto(e, "noticesToDate")
                            }
                            handleKeyDown={(e) =>
                              handlePhotoDateEnterKey(e, "noticesToDate")
                            }
                          ></DateInput>
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="mt-3 d-flex flex-wrap  gap-3">
                      {(reportPhotoinitial &&
                        loadPhotoList?.DataList?.length > 0) ? (
                        <div className="d-flex flex-wrap align-items-start">
                          <label
                            className="fs-5 fw-bold"
                            style={{ color: "#009759" }}
                          >
                            Data loaded successfully. Click download button to
                            export PDF.
                          </label>
                        </div>
                      ) :
                        (reportPhotoinitial &&
                          loadPhotoList?.DataList?.length === 0) ? (
                          <div className="d-flex flex-wrap align-items-start">
                            <label className="fs-5 fw-bold text-danger">
                              No Data Available
                            </label>
                          </div>
                        ) :
                          <p className="fst-italic font-bold">
                            Note : You can select a date range of up to six month only.
                          </p>
                      }
                      {/* {(Object.keys(loadPhotoList)?.length === 0 || */}
                      <div className="d-flex flex-wrap ms-auto">
                        {(loadPhotoList?.DataList?.length === undefined ||
                          loadPhotoList?.DataList?.length === 0) && (
                            <Button
                              className="me-2"
                              label={"LOAD DATA"}
                              type={"submit"}
                              variant="danger"
                              status={"btn-label"}
                              imgsrc={loaddataimg}
                              disabled={false}
                              onClick={photoloadData}
                            />
                          )}
                        {loadPhotoList?.DataList?.length > 0 && (
                          <>
                            <Button
                              className="me-2"
                              label={"CANCEL"}
                              type={"submit"}
                              icon={"fa-solid fa-xmark"}
                              variant="danger"
                              status={"primary"}
                              disabled={false}
                              onClick={handlePhotoCancel}
                            />
                            <Button
                              className="me-2"
                              icon={"fa-solid fa-download"}
                              label={"Download"}
                              type={"submit"}
                              variant="danger"
                              status={"success"}
                              disabled={ispdfLoading}
                              onClick={() => { handlePhotoPDF(); }}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {event log} */}
      <div className="accordion" id="accordion-eventLog">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingeventLog">
              <button
                className="accordion-button collapsed text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#connections-accordian"
                onClick={handleEventLog}
                aria-expanded="false"
              >
                Event Log
                {/* <CheckBoxInput
                  name="eventLog"
                  id="eventLog"
                  onClick={handleEventLog}
                  checked={eventLog}
                /> */}
              </button>
            </div>
            <div
              id="connections-accordian"
              className={`accordion-collapse
                ${eventLog ? "show" : "collapse"}`}
              aria-labelledby="headingeventLog"
            >
              <div className="accordion-body ">
                <div>
                  <h4 className="inner-header-bg text-color">
                    {" "}
                    <i className="fa-solid fa-filter me-2"></i>Filter{" "}
                  </h4>
                  <form
                  // onSubmit={handleSubmit}
                  >
                    <div className="row">
                      <div className="m-0 d-flex flex-wrap align-items-center">
                        {/* Frequency */}
                        <div className="col-md-4 col-sm-12 d-flex flex-wrap align-items-center me-2">
                          <label className="fs-5" style={{ minWidth: "150px" }}>
                            Public User Last Name :
                          </label>

                          <strong className="fs-5 text-end mx-2">
                            {row?.LastName ||
                              rows?.LastName ||
                              infoInformationList?.LastName}
                          </strong>
                        </div>

                        {/* Limit */}
                        <div className="col-md-4 col-sm-12 d-flex flex-wrap align-items-center">
                          <label className="fs-5" style={{ minWidth: "150px" }}>
                            Public User First Name :
                          </label>
                          <strong className="fs-5 text-end mx-2">
                            {row?.FirstName ||
                              rows?.FirstName ||
                              infoInformationList?.FirstName}
                          </strong>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-floating mb-3">
                          <DateInput
                            value={eventlogList?.date}
                            handleChange={(date) => handleEventDateChange(date)}
                            handleBlur={(e) => handleBlur(e, "date")}
                            handleKeyDown={(e) =>
                              handleEventLogDateEnterKey(e, "date")
                            }
                            name="date"
                            label={"Date"}
                            minDate={new Date(2017, 0, 1)}
                            maxDate={new Date()}
                            required={true}
                            isClearable={
                              eventlogList?.date !== null &&
                              eventlogList?.date !== ""
                            }
                            errorMessage={errorMessage}
                            disabled={checkEventLogData === 1}
                            yearDropDown={false}
                            monthDropDown={false}
                          // handleBlur={(e) => handleDateBlurEventlog(e, "date")}
                          ></DateInput>
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="mt-3 d-flex flex-wrap  gap-3">
                      {reportEventLoginitial && checkEventLogData > 0 && (
                        <div className="d-flex flex-wrap align-items-start">
                          <label
                            className="fs-5 fw-bold"
                            style={{ color: "#009759" }}
                          >
                            Data loaded successfully. Click download button to
                            export PDF.
                          </label>
                        </div>
                      )}

                      {reportEventLoginitial && checkEventLogData === 0 && (
                        <div className="d-flex flex-wrap align-items-start">
                          <label className="fs-5 fw-bold text-danger">
                            No Data Available
                          </label>
                        </div>
                      )}

                      <div className="d-flex flex-wrap ms-auto">
                        {checkEventLogData === 0 && (
                          <Button
                            className="me-2"
                            label={"LOAD DATA"}
                            type={"submit"}
                            variant="danger"
                            imgsrc={loaddataimg}
                            status={"btn-label"}
                            disabled={false}
                            onClick={eventLogloadData}
                          />
                        )}
                        {checkEventLogData === 1 && (
                          <>
                            <Button
                              className="me-2"
                              label={"CANCEL"}
                              type={"submit"}
                              variant="danger"
                              status={"primary"}
                              icon={"fa-solid fa-xmark"}
                              disabled={false}
                              onClick={handleEventLogCancel}
                            />

                            <Button
                              className="me-2"
                              icon={"fa-solid fa-download"}
                              label={"Download"}
                              type={"submit"}
                              variant="danger"
                              status={"success"}
                              disabled={false}
                              onClick={handleEventLogDownload}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(PublicUserReport);
